import { render, staticRenderFns } from "./block-theme.vue?vue&type=template&id=0028fb0d&scoped=true&"
import script from "./block-theme.vue?vue&type=script&lang=js&"
export * from "./block-theme.vue?vue&type=script&lang=js&"
import style0 from "./block-theme.vue?vue&type=style&index=0&id=0028fb0d&lang=scss&scoped=true&"
import style1 from "./block-theme.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0028fb0d",
  null
  
)

export default component.exports